import 'es6-promise/auto';
import 'intersection-observer';
import 'whatwg-fetch';

if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function forEach(callback, thisArg) {
    thisArg = thisArg || window;

    for (let i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

if (!Array.from) {
  let toStr = Object.prototype.toString;

  let isCallable = (fn) => {
    return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
  };

  let toInteger = (value) => {
    let number = Number(value);

    if (isNaN(number)) {
      return 0;
    }

    if (number === 0 || !isFinite(number)) {
      return number;
    }

    return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
  };

  let maxSafeInteger = Math.pow(2, 53) - 1;

  let toLength = (value) => {
    let len = toInteger(value);

    return Math.min(Math.max(len, 0), maxSafeInteger);
  };

  Array.from = function from(arrayLike) {
    let C = this;

    let items = Object(arrayLike);

    if (arrayLike == null) {
      throw new TypeError('Array.from requires an array-like object - not null or undefined');
    }

    // eslint-disable-next-line prefer-rest-params
    let mapFn = arguments.length > 1 ? arguments[1] : undefined;
    let T;

    if (typeof mapFn !== 'undefined') {
      if (!isCallable(mapFn)) {
        throw new TypeError('Array.from: when provided, the second argument must be a function');
      }

      if (arguments.length > 2) {
        // eslint-disable-next-line prefer-rest-params
        T = arguments[2];
      }
    }

    let len = toLength(items.length);
    let A = isCallable(C) ? Object(new C(len)) : new Array(len);
    let k = 0;
    let kValue;

    while (k < len) {
      kValue = items[k];
      if (mapFn) {
        A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
      } else {
        A[k] = kValue;
      }

      k += 1;
    }

    A.length = len;

    return A;
  };
}

if (!Array.prototype.find) {
  // eslint-disable-next-line no-extend-native
  Object.defineProperty(Array.prototype, 'find', {
    value(predicate) {
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      let o = Object(this);

      // eslint-disable-next-line no-bitwise
      let len = o.length >>> 0;

      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }

      // eslint-disable-next-line prefer-rest-params
      let thisArg = arguments[1];
      let k = 0;

      while (k < len) {
        let kValue = o[k];

        if (predicate.call(thisArg, kValue, k, o)) {
          return kValue;
        }

        k++;
      }

      return undefined;
    },
    configurable: true,
    writable: true
  });
}

if (!Array.prototype.includes) {
  Object.defineProperty(Array.prototype, 'includes', {
    value(searchElement, fromIndex) {
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      let o = Object(this);
      let len = o.length >>> 0;

      if (len === 0) {
        return false;
      }

      let n = fromIndex | 0;
      let k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

      function sameValueZero(x, y) {
        return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
      }

      while (k < len) {
        if (sameValueZero(o[k], searchElement)) {
          return true;
        }

        k++;
      }

      return false;
    }
  });
}

(function (prototypes) {
  prototypes.forEach((prototype) => {
    if (prototype.hasOwnProperty('prepend')) {
      return;
    }

    Object.defineProperty(prototype, 'prepend', {
      configurable: true,
      enumerable: true,
      writable: true,
      value() {
        let args = Array.prototype.slice.call(arguments);
        let documentFragment = document.createDocumentFragment();

        args.forEach((arg) => {
          let isNode = arg instanceof Node;

          documentFragment.appendChild(isNode ? arg : document.createTextNode(String(arg)));
        });

        this.insertBefore(documentFragment, this.firstChild);
      }
    });
  });

  prototypes.forEach((prototype) => {
    if (prototype.hasOwnProperty('append')) {
      return;
    }

    Object.defineProperty(prototype, 'append', {
      configurable: true,
      enumerable: true,
      writable: true,
      value() {
        let args = Array.prototype.slice.call(arguments);
        let documentFragment = document.createDocumentFragment();

        args.forEach((arg) => {
          let isNode = arg instanceof Node;

          documentFragment.appendChild(isNode ? arg : document.createTextNode(String(arg)));
        });

        this.appendChild(documentFragment);
      }
    });
  });
})([Element.prototype, Document.prototype, DocumentFragment.prototype]);
